import { connect } from 'react-redux'
import SummaryTile from '../components/summary_tile'
import { fetchSummary, closeSummary } from '../actions/summaries_index'
import { selectIsManagerSite } from '../selectors'

const mapStateToProps = (state, ownProps) => {
  const slice = state.summaries[ownProps.summaryKey]

  return {
    loading: slice?.loading || false,
    error: slice?.error || null,
    data: slice?.data || null,
    isOpen: Boolean(slice),
    isManagerSite: selectIsManagerSite(state),
    currencySymbol: state.leaderboardV2.currencySymbol,
    purseDecimalPlaces: state.leaderboardV2.purseDecimalPlaces,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchSummary: () => dispatch(fetchSummary(ownProps.summaryKey)),
  closeSummary: () => dispatch(closeSummary(ownProps.summaryKey)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SummaryTile)
